import { useDictationClose } from '@/features/dictation/dictationBubble/hooks/useDictationClose';
import { useDictationStore } from '@/features/dictation/dictationBubble/store/useDictationStore';
import { useIsMobile } from '@/hooks/useWindowDimensions';
import { cn } from '@/lib/cn';
import {
  bubbleExitAnimation,
  DICTATION_BUBBLE_Z_INDEX_CLASS,
  DictationBubbleShell,
  DictationCloseButton,
  DictationErrorContent,
  MESSAGE_DISPLAY_DURATION_MS,
} from '@heidi/dictate';
import { useIsPresent } from 'motion/react';
import { useEffect, useRef } from 'react';

export const DictationError = () => {
  const isPresent = useIsPresent();
  const isMobile = useIsMobile();

  // Read from store
  const storeMessageLevel = useDictationStore((s) => s.messageLevel);
  const storeErrorCode = useDictationStore((s) => s.errorCode);
  const persistent = useDictationStore((s) => s.persistent);
  const { handleClose, reset } = useDictationClose();

  // Capture values - only update when component is present (not exiting)
  const capturedValues = useRef({
    messageLevel: storeMessageLevel,
    errorCode: storeErrorCode,
  });

  if (isPresent) {
    capturedValues.current = {
      messageLevel: storeMessageLevel,
      errorCode: storeErrorCode,
    };
  }

  // Use captured values for display (frozen during exit animation)
  const { messageLevel, errorCode } = capturedValues.current;

  useEffect(() => {
    if (persistent) return;

    const timeoutId = setTimeout(() => {
      reset();
    }, MESSAGE_DISPLAY_DURATION_MS);

    return () => clearTimeout(timeoutId);
  }, [errorCode, persistent, reset]);

  return (
    <DictationBubbleShell
      animation={bubbleExitAnimation}
      opaque
      className={cn(
        'fixed inset-x-0 mx-auto flex h-15 w-fit min-w-87.5 items-center justify-center',
        DICTATION_BUBBLE_Z_INDEX_CLASS,
        isMobile ? 'bottom-32' : 'bottom-6'
      )}
    >
      <DictationCloseButton onClose={handleClose} />
      <DictationErrorContent
        errorCode={errorCode}
        messageLevel={messageLevel}
        showHelpLink
      />
    </DictationBubbleShell>
  );
};
